<div *ngIf="isLoggedIn">
	<header [title]="title" (reloadPage)="reloadPage()"></header>

	<nav *ngIf="showNav" [class]="layoutCssClass" [ngClass]="{ 'no-footer': !showFooter }" [expand]="expand" (setLayoutClass)="setLayoutClass()" (reloadPage)="reloadPage()"></nav>

	<content [class]="layoutCssClass" [ngClass]="{ 'no-nav': !showNav, 'no-footer': !showFooter }">
		<!-- Show Admin component for admin-only users -->
		<app-admin *ngIf="showAdmin"></app-admin>
		
		<!-- Show normal routing otherwise -->
		<router-outlet *ngIf="!showAdmin"></router-outlet>
	</content>

	<footer *ngIf="showFooter"></footer>
</div>

<!-- <div *ngIf="isLoginPage">
	<router-outlet></router-outlet>
</div> -->

<div *ngIf="modal" class="modal-window">
	<div class="locked"></div>
</div>

<div *ngIf="!isLoggedIn && layoutCssClass !== 'noaccess'">
    <div class="auth">Authenticating...</div>
</div>

<access *ngIf="layoutCssClass === 'noaccess'"></access>
<error *ngIf="error !== ''" [message]="error"></error>

<div *ngIf="showAlert" class="modal-window">
	<div class="locked"></div>
	<alert
		[title]="alertTitle"
		[message]="alertMessage"
		[continueText]="alertContinueText"
		[cancelText]="alertCancelText"
		(continueEvent)="alertContinue()"
		(cancelEvent)="alertCancel()"></alert>
</div>

<sdk-loading [isLoading]="isLoading"></sdk-loading>

<!-- Global Notification Component -->
<app-notification></app-notification>

<!-- Global Confirmation Dialog -->
<app-confirmation-dialog></app-confirmation-dialog>

<!-- Global Fullscreen Loading -->
<app-fullscreen-loading></app-fullscreen-loading>
